/* shto-price-tabs: the "vs. a showroom chair" / "vs. massage appointments" tabs. Clicking a tab (or the arrow keys,
   Home and End on a focused tab) shows its comparison card and review; the address is never changed.
   In the theme editor, selecting a Tab block shows that tab. */
(function () {
  if (window.ShtoPriceTabs) return;
  window.ShtoPriceTabs = true;

  function show(root, id, focus) {
    var tabs = root.querySelectorAll('[data-shto-tab]');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i].getAttribute('data-shto-tab') === id;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].tabIndex = on ? 0 : -1;
      if (on && focus) tabs[i].focus();
    }
    var panels = root.querySelectorAll('[data-shto-panel]');
    for (var j = 0; j < panels.length; j++) panels[j].hidden = panels[j].getAttribute('data-shto-panel') !== id;
  }

  function init(root) {
    if (root.shtoPriceTabs) return;
    root.shtoPriceTabs = true;
    root.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('[data-shto-tab]');
      if (tab && root.contains(tab)) show(root, tab.getAttribute('data-shto-tab'), false);
    });
    root.addEventListener('keydown', function (e) {
      var tab = e.target.closest && e.target.closest('[data-shto-tab]');
      if (!tab) return;
      var list = Array.prototype.slice.call(root.querySelectorAll('[data-shto-tab]'));
      var i = list.indexOf(tab), to = -1;
      if (e.key === 'ArrowRight') to = (i + 1) % list.length;
      else if (e.key === 'ArrowLeft') to = (i - 1 + list.length) % list.length;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = list.length - 1;
      if (to < 0) return;
      e.preventDefault();
      show(root, list[to].getAttribute('data-shto-tab'), true);
    });
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-shto-price-tabs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-shto-price-tabs]');
    var tab = e.target.closest && e.target.closest('[data-shto-tab]');
    if (root && tab) show(root, tab.getAttribute('data-shto-tab'), false);
  });
})();
